<mat-card class="prescription-list-container">
    <div class="row">
        <div class="col-md-4">
            Prescriptions
        </div>
        <div class="col-md-8 text-end">
            <form [formGroup]="orderFilterForm">
                <mat-form-field appearance="outline" class="me-2">
                    <mat-label>Search</mat-label>
                    <input type="text" formControlName="search" matInput/>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                        <mat-option [value]="status" *ngFor="let status of orderStatuses">
                            {{status.status}}
                        </mat-option>
                    </mat-select>
                    <button *ngIf="selectedStatus" (click)="resetStatus($event)" mat-icon-button matSuffix
                        [attr.aria-label]="'Remove status'">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-form-field>
                
            </form>
        </div>
    </div>

    <mat-paginator [length]="totalNumberOfOrders" [pageIndex]="page-1" [pageSize]="limit"
        [pageSizeOptions]="[10, 15, 20]" showFirstLastButtons (page)="onPageChange($event)"
        aria-label="Select page of prescriptions">
    </mat-paginator>

    <div class="py-2r">
        <mat-divider></mat-divider>
    </div>

    <table mat-table [dataSource]="ordersDataSource" matSort (matSortChange)="sortOrders($event)"
        class="prescription-list">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let order">{{order.id}}</td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let order">{{getEntityName(order)}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let order"> 
                <span class="badge {{getBadgeBackground(order.status)}}">{{order.status.status}}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="sage">
            <th mat-header-cell *matHeaderCellDef>Sage</th>
            <td mat-cell *matCellDef="let order">{{getSageSyncLabel(order)}}</td>
        </ng-container>

        <ng-container matColumnDef="contact">
            <th mat-header-cell *matHeaderCellDef>Contact</th>
            <td mat-cell *matCellDef="let order">{{getOwnerPhoneNumber(order)}}</td>
        </ng-container>


        <ng-container matColumnDef="meds_assigned">
            <th mat-header-cell *matHeaderCellDef>Medicine assigned</th>
            <td mat-cell *matCellDef="let order">
                <mat-checkbox [disableRipple]="true" (click)="$event.preventDefault()" color="primary"
                    [checked]="isMedicineAssigned(order)">Medicine assigned</mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="entities_assigned">
            <th mat-header-cell *matHeaderCellDef>Entities assigned</th>
            <td mat-cell *matCellDef="let order">
                <mat-checkbox [disableRipple]="true" (click)="$event.preventDefault()" color="primary"
                    [checked]="isEntityAssigned(order)">Entity assigned</mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="view_prescription_file">
            <th mat-header-cell *matHeaderCellDef>Prescription file</th>
            <td mat-cell *matCellDef="let order">
                <button (click)="openPrescriptionFile($event, order)" mat-stroked-button>
                    <mat-icon>open_in_new</mat-icon> Open
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by date created">Created
            </th>
            <td mat-cell *matCellDef="let order">{{getCreationTime(order)}}</td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by date updated">
                Updated
            </th>
            <td mat-cell *matCellDef="let order">{{formatTime(order.updated_at)}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row (click)="openPrescription(row.id)" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

</mat-card>